import React from 'react'
import NumberFormat from 'react-number-format';
import { Modal, ModalHeader, ModalBody, Row, Col, Label, Input, FormGroup, Button, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import WizardError from '../../../auth/register/WizardError';

const AddConfigRoot = ({ isOpen, toggle, closeBtn, min, max, setMin, setMax, price, setPrice, submittingSave, saveRange }) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered modalClassName="theme-modal" >
            <ModalHeader toggle={toggle} tag="div" className="px-card bg-light border-0 flex-between-center" close={closeBtn}>
                Registro de rango de servicio
            </ModalHeader>
            <ModalBody className="px-card pb-card pt-card fs--1">
                <Row form >
                    <Col tag={FormGroup}>
                        <Label>Mínimo de propiedades</Label>
                        <Input type='number' value={min} onChange={({ target }) => setMin(target.value)} min={1} />
                    </Col>
                </Row>
                <Row form >
                    <Col tag={FormGroup}>
                        <Label>Máximo de propiedades</Label>
                        <Input type='number' value={max} onChange={({ target }) => setMax(target.value)} />
                        <WizardError className='fs--1' error={max <= min ? 'Ingrese un rango válido.' : ''} />
                    </Col>
                </Row>
                <Row>
                    <Col tag={FormGroup}>
                        <Label >Monto por propiedad en este rango</Label>
                        <NumberFormat placeholder='Ingrese un monto' value={price} onValueChange={({ value }) => setPrice(value)} className='form-control' prefix='$ ' thousandSeparator fixedDecimalScale decimalScale={2} />
                        <WizardError className='fs--1' error={!price ? 'Ingrese un monto.' : ''} />
                    </Col>
                </Row >
                <Row>
                    <Col tag={FormGroup} className='d-flex align-items-end'>
                        <Button color='falcon-default' className='btn-block' disabled={submittingSave || max <= min || !price} onClick={() => { saveRange(min, max, price) }} icon={faSave}>
                            {!submittingSave ? <FontAwesomeIcon icon={faSave} className='mr-2' /> : <Spinner size='sm' className='mr-2' />}
                            Guardar</Button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    )
}

export default AddConfigRoot;